<template>
  <div class="inf_style">
    <el-page-header @back="goBack" class="pc_hide_style"> </el-page-header>
    <div class="config_title_style">个人信息</div>
    <el-descriptions :column="1" border>
      <el-descriptions-item label="姓名"
        >{{ userVO.firstName }}{{ userVO.lastName }}</el-descriptions-item
      >
      <!-- <el-descriptions-item label="性别">{{ userVO.sex }}</el-descriptions-item> -->
      <el-descriptions-item label="邀请码">{{
        userVO.agentId
      }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      userVO: {},
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    goBack() {
      // this.$router.back();
      this.$router.push({
        path: "/menu",
      });
    },
    getUser() {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmUser/getUserById", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.userVO = res.data.data;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width:768px) {
  .inf_style {
    padding: 40px;
  }
}
@media (min-width:768px) {
  .pc_hide_style {
    display: none;
  }
}
.config_title_style {
  font-size: 22px;
  color: #202f3b;
  font-weight: bold;
  margin-bottom: 25px;
}
</style>